import ReactGA from 'react-ga';

export const eventTracking = (payload) => {
    ReactGA.event(payload);
}